define [], () ->
  ($resource, RENTAPPLICATION_API_URL) ->
    $resource(
      "#{RENTAPPLICATION_API_URL}/api/v2/account/:id/",
      {},
      {
        get:
          cache: true
        query:
          cache: true
          isArray: false
        getMe:
          url: "#{RENTAPPLICATION_API_URL}/api/v1/account/me/"
          cache: true
      }
    )



// WEBPACK FOOTER //
// ./resources/Account.coffee